import { Typography } from '@material-ui/core'

import { PolicyTable } from '../../types/cancelAndModifyPolicies'
import useStyles from './styles/RatePlansPoliciesActionModalRow.styles'

interface RatePlansPoliciesActionModalRowProps {
  policiesData: PolicyTable
}

const RatePlansPoliciesActionModalRow: React.FC<
  RatePlansPoliciesActionModalRowProps
> = ({ policiesData }) => {
  const classes = useStyles()
  const {
    priority,
    penaltyAmount,
    deadline,
    deadlineTimeOffset,
    penaltyType,
    policyType
  } = policiesData
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="body2">{priority}</Typography>
      </div>
      <div>
        <Typography variant="body2">{penaltyAmount}</Typography>
      </div>
      <div>
        <Typography variant="body2">{penaltyType}</Typography>
      </div>
      <div>
        <Typography variant="body2">{deadline}</Typography>
      </div>
      <div>
        <Typography variant="body2">{deadlineTimeOffset}</Typography>
      </div>
      <div>
        <Typography variant="body2">{policyType}</Typography>
      </div>
    </div>
  )
}
export default RatePlansPoliciesActionModalRow
